// extracted by mini-css-extract-plugin
export default {"block":"Register_block__zd7NB","link":"Register_link__pxR1Y"};